export default "__VITE_ASSET__ihFYbBBU__"